import { Card } from '../types';

type FormatedCard = Card & {
  isVirtualCard?: boolean;
};

export default function addVirtualCardFlag(cards: FormatedCard[]): FormatedCard[] {
  const formattedCards: FormatedCard[] = [...cards];

  const virtualCard = formattedCards.find(({ isOTTCard }) => isOTTCard);

  if (virtualCard) {
    virtualCard.isVirtualCard = true;
  }

  return formattedCards;
}
